import { css } from '@emotion/core';
import { aNormalize, buttonNormalize, media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
var showMarker = colour => /*#__PURE__*/css("background-color:", colour, ";transition:background-color 0.2s ease-out;");
export var menuItem = /*#__PURE__*/css("display:flex;background-color:", colors.interactive.surface.default, ";position:relative;align-items:center;gap:8px;::before{display:block;position:absolute;content:'';background-color:transparent;transition:background-color 0.2s ease-out;}:hover{cursor:pointer;background-color:", colors.interactive.surface.hover, ";::before{", showMarker(colors.interactive.base.default), "}}:active{::before{", showMarker(colors.interactive.base.pressed), "}}");
export var sizeRow = {
  name: "xgff9b",
  styles: "height:32px;"
};
export var sizeFull = {
  name: "1jsohtw",
  styles: "height:48px;"
};
export var sizeCompact = {
  name: "u1jr60",
  styles: "height:40px;"
};
export var sizeAuto = /*#__PURE__*/css(sizeFull, " ", media('>=desktop'), "{", sizeCompact, "}");
export var indicatorBottom = /*#__PURE__*/css("width:fit-content;:hover{background-color:", colors.neutral.surface.default, ";}::before{height:3px;border-radius:3px;top:calc(100% - 3px);width:100%;}");
export var indicatorLeft = /*#__PURE__*/css("justify-content:stretch;:hover{background-color:", colors.neutral.surface.default, ";}::before{left:0;border-radius:3px;position:absolute;width:3px;height:", tokens.typography.bodyBold.lineHeight, ";}");
export var indicatorSelected = /*#__PURE__*/css(":hover{::before{", showMarker(colors.interactive.base.hover), "}}::before{", showMarker(colors.interactive.base.default), "}");
export var showIndicator = /*#__PURE__*/css(":hover{::before{", showMarker(colors.interactive.base.hover), "}}::before{", showMarker(colors.interactive.base.default), "}");
export var highlight = /*#__PURE__*/css("background-color:", colors.neutral.subdued.default, ";:hover{", showMarker(colors.neutral.subdued.hover), "}");
var menuContent = /*#__PURE__*/css(designTokenFonts.bodyBold, ";white-space:nowrap;display:flex;align-items:center;gap:8px;height:100%;padding:0;");
export var menuContentPadding = {
  name: "gajhq5",
  styles: "padding-left:16px;padding-right:16px;"
};
export var indent = {
  name: "qcqkus",
  styles: "padding-left:40px;"
};
export var anchor = /*#__PURE__*/css("flex:1;", aNormalize, " ", menuContent);
export var button = /*#__PURE__*/css(buttonNormalize, " ", menuContent, " flex:1;:hover{cursor:pointer;}");
export var iconButton = /*#__PURE__*/css(buttonNormalize, " border-radius:", tokens.borderRadius.mini, ";display:flex;flex-direction:row;align-items:center;");
export var iconButtonPadding = {
  name: "1d6jkz0",
  styles: "padding:8px;margin-right:8px;"
};
export var iconButtonInteractive = /*#__PURE__*/css(":hover{background-color:", colors.neutral.surface.hover, ";color:", colors.neutral.heavy.hover, ";}:active{background-color:", colors.neutral.surface.pressed, ";color:", colors.neutral.heavy.pressed, ";}");
export var icon = /*#__PURE__*/css("transition:transform 0.3s ease-in-out;color:", colors.neutral.heavy.default, ";");
export var iconExpanded = {
  name: "4ky835",
  styles: "transform:rotate(180deg);"
};
export var newBadge = /*#__PURE__*/css("border-radius:100px;padding:4px 8px;margin-right:16px;background-color:", colors.accentTwo.trim.default, ";color:", colors.neutral.surface.default, ";", designTokenFonts.miniBold, ";");